import { render } from "./ColumnChart.vue?vue&type=template&id=094c3d7a&scoped=true"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"

import "./ColumnChart.vue?vue&type=style&index=0&id=094c3d7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094c3d7a"]])

export default __exports__